
// src/reducers/report-reducer.js

import {
  FETCH_DIARY_REPORT_COMPLETED, FETCH_DIARY_REPORT_FAILED,
  FETCH_DIARY_REPORT_REQUESTED,
  POST_DIARY_REPORT_COMPLETED,
  POST_DIARY_REPORT_FAILED,
  POST_DIARY_REPORT_REQUESTED
} from "../actions/diary-report";
import {mergeArray} from "../helpers/store";

const initialState = {
  isFetching: false,
  isFetchFailed: false,
  isPosting: false,
  isPostFailed: false,
  isWeeklyReport: false,
  isMonthlyReport: false,
  weeklyReportStartDate: undefined,
  monthlyReportStartDate: undefined,
  inputDiaryUserCount: undefined,
}

export default function diaryReportReducer(state = initialState, action = {}) {
  switch(action.type) {
    case FETCH_DIARY_REPORT_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        isFetchFailed: false,
      })
    case FETCH_DIARY_REPORT_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: true,
      })

    case FETCH_DIARY_REPORT_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        isWeeklyReport: action.results.is_weekly_report,
        isMonthlyReport: action.results.is_monthly_report,
        weeklyReportStartDate: action.results.weekly_report_start_date,
        monthlyReportStartDate: action.results.monthly_report_start_date,
        inputDiaryUserCount: action.results.input_diary_user_count,
      })

    case POST_DIARY_REPORT_REQUESTED:
      return Object.assign({}, state, {
        isPosting: true,
        isPostFailed: false,
      })

    case POST_DIARY_REPORT_FAILED:
      return Object.assign({}, state, {
        isPosting: false,
        isPostFailed: true,
      })

    case POST_DIARY_REPORT_COMPLETED:
      return Object.assign({}, state, {
        isPosting: false,
        isPostFailed: true,
        isWeeklyReport: action.results.is_weekly_report,
        isMonthlyReport: action.results.is_monthly_report,
        weeklyReportStartDate: action.results.weekly_report_start_date,
        monthlyReportStartDate: action.results.monthly_report_start_date,
        inputDiaryUserCount: action.results.input_diary_user_count,
       })

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/diary-report-reducer.js